import { connect } from "react-redux";
import { RootState } from "../state/reducers";
import { DisabledState } from "../state/reducers/disabledReducer";
import { ID, Layout, Section as SectionType } from "../types";
import PartList from "./PartList";

interface SectionProps {
  section?: SectionType;
  layout: Layout;
  disabled: DisabledState;
}

const Section: React.FC<SectionProps> = ({ section, layout, disabled }) => {
  if (!section) return null;
  const sectionDisabled = section.parts.every((partId) =>
    disabled.includes(partId)
  );
  return (
    <>
      <h3>{section.label}</h3>
      {sectionDisabled ? (
        <p>Options are included or excluded because of a package.</p>
      ) : (
        <PartList
          parts={section.parts}
          sectionType={section.type}
          layout={layout}
        />
      )}
    </>
  );
};

interface ConnectProps {
  sectionId: ID;
  layout: Layout;
}

export default connect((state: RootState, props: ConnectProps) => {
  const { sectionId, layout } = props;
  return {
    layout,
    disabled: state.disabled,
    section: state.formData.entities.sections.byId[sectionId],
  };
}, {})(Section);
